import { render } from "./PortalApp.vue?vue&type=template&id=44270a8c&scoped=true"
import script from "./PortalApp.vue?vue&type=script&lang=js"
export * from "./PortalApp.vue?vue&type=script&lang=js"

import "./PortalApp.vue?vue&type=style&index=0&id=44270a8c&lang=scss&scoped=true"

import exportComponent from "/builds/apps/elevate/shepherd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44270a8c"]])

export default __exports__